import CatalogHtml from 'page/catalog/CatalogHtml'
import { getStandProps } from 'server/stand'

export default CatalogHtml
export const getServerSideProps = getStandProps
